export default "__VITE_ASSET__3fa04adb__"